import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { TipoSolicitudExListComponent } from './tipossolicitudes/tiposolicitudEx-list.component';
import { SolicitudExService } from './datosbasicos/datosbasicosEx.service';
import { SolicitudExEditComponent } from './datosbasicos/solicitudEx-edit.component';
import { TasasExComponent } from './tasas/tasasEx.component';
import { TasasExService } from './tasas/tasasEx.service';
import { AnulacionExEditComponent } from './anulacion/anulacionEx-edit.component';
import { AnulacionExService } from './anulacion/anulacionEx.service';
import { DeclSuplementariaExComponent } from './declsuplemetaria/declsuplemetaria.component';
import { DeclaracionSuplementariaService } from './declsuplemetaria/declsuplemetaria.service';
import { ProductosSolicitudExListComponent } from './productos/productosEx-list.component';
import { ProductosExService } from './productos/productosEx.service';
import { ProductoExEditComponent } from './productos/productosEx-edit.component';
import { EmbalajeExEditComponent } from './productos/embalajesEx-edit.component';
import { PreviaInspectorExEditComponent } from './previaInspector/previaInspectorEx-edit.component';
import { PreviaInspectorExService } from './previaInspector/previaInspectorEx.service';
import { DocumentosExService } from './documentos/documentosEx.service';
import { DocumentosExListComponent } from './documentos/documentosEx-list.component';
import { DocumentosExEditComponent } from './documentos/documentosEx-edit.component';
import { EnvioExService } from './envio/envioEx.service';
import { EnvioExComponent } from './envio/envioEx.component';
import { InspeccionesExComponent } from './inspecciones/inspeccionesEx.component';
import { InspeccionesExService } from './inspecciones/inspeccionesEx.service';
import { MatriculaPrecintoPopupComponent } from './components/popup/matriculaprecinto/matriculaPrecintoPopup.component';
import { ReexportacionEditComponent } from './reexportacion/reexportacion-edit.component';
import { ReexportacionService } from './reexportacion/reexportacion.service';
import { AlegacionExComponent } from './alegacion/alegacionEx.component';
import { DocumentoAlegacionExEditComponent } from './alegacion/documentoAlegacionEx-edit.component';
import { AlegacionExService } from './alegacion/alegacionEx.service';
import { NumeroSeguridadEditComponent } from './envio/numerosseguridad/numerosseguridad-edit.component';
import { NumerosSeguridadExService } from './envio/numerosseguridad/numerosseguridad.service';
import { NumeroSeguridadListComponent } from './envio/numerosseguridad/numerosseguridad-list.component';
import { CopiaCFExEditComponent } from './envio/copiaCF/copiaCFEx-edit.component';
import { CopiaCFExService } from './envio/copiaCF/copiaCFEx.service';
import { CopiaCFExListComponent } from './envio/copiaCF/copiaCFEx-list.component';
import { RelacionatestacionesComponent } from './relacionatestaciones/relacionatestaciones.component';
import { RelacionAtestacionesService } from './relacionatestaciones/relacionatestaciones.service';
import { SolicitudesExRoutingModule } from './solicitudesEx-routing.module';
import { LaboratorioExWrapperComponent } from './laboratorio/laboratorioEx-wrapper/laboratorioEx-wrapper.component';
import { LaboratorioExDatosComponent } from './laboratorio/laboratorioEx-datos/laboratorioEx-datos.component';
import { LaboratorioExEnvioMuestrasComponent } from './laboratorio/laboratorioEx-enviomuestras/laboratorioEx-enviomuestras.component';
import { LaboratorioExResultadoEnvioMuestrasComponent } from './laboratorio/laboratorioEx-resultadoenviomuestras/laboratorioEx-resultadoenviomuestras.component';
import { LaboratorioExDocumentosListComponent } from './laboratorio/laboratorioEx-documentos-list/laboratorioEx-documentos-list.component';
import { LaboratorioExDocumentosEditComponent } from './laboratorio/laboratorioEx-documentos-edit/laboratorioEx-documentos-edit.component';
import { LaboratorioExService } from './laboratorio/laboratorioEx.service';
import { DeclaracionAdicionalPopupComponent } from './components/popup/declaracionadicional/declaracionadicionalPopup.component';
import { SeguimientoExService } from './seguimiento/seguimientoEx.service';
import { SeguimientoExEditComponent } from './seguimiento/seguimientoEx-edit.component';
import { SeguimientosExListComponent } from './seguimiento/seguimientosEx-list.component';
import { ReasignacionPcfWrapperComponent } from './inspecciones/reasignacionpcf-wrapper/reasignacionpcf-wrapper.component';
import { ReasignacionPcfEditComponent } from './inspecciones/reasignacionpcf-edit/reasignacionpcf-edit.component';

@NgModule({
    declarations: [
        TipoSolicitudExListComponent,
        SolicitudExEditComponent,
        ProductosSolicitudExListComponent,
        ProductoExEditComponent,
        EmbalajeExEditComponent,
        TasasExComponent,
        InspeccionesExComponent,
        AlegacionExComponent,
        DocumentoAlegacionExEditComponent,
        AnulacionExEditComponent,
        PreviaInspectorExEditComponent,
        ReexportacionEditComponent,
        RelacionatestacionesComponent,
        DeclSuplementariaExComponent,
        DocumentosExListComponent,
        DocumentosExEditComponent,
        SeguimientosExListComponent,
        SeguimientoExEditComponent,
        EnvioExComponent,
        MatriculaPrecintoPopupComponent,
        DeclaracionAdicionalPopupComponent,
        NumeroSeguridadEditComponent,
        NumeroSeguridadListComponent,
        CopiaCFExEditComponent,
        CopiaCFExListComponent,
        LaboratorioExWrapperComponent,
        LaboratorioExDatosComponent,
        LaboratorioExEnvioMuestrasComponent,
        LaboratorioExResultadoEnvioMuestrasComponent,
        LaboratorioExDocumentosListComponent,
        LaboratorioExDocumentosEditComponent,
        ReasignacionPcfEditComponent,
        ReasignacionPcfWrapperComponent
    ],
    exports: [MatriculaPrecintoPopupComponent, DeclaracionAdicionalPopupComponent],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, SolicitudesExRoutingModule],
    providers: [
        SolicitudExService,
        ProductosExService,
        TasasExService,
        InspeccionesExService,
        AnulacionExService,
        AlegacionExService,
        PreviaInspectorExService,
        ReexportacionService,
        RelacionAtestacionesService,
        DeclaracionSuplementariaService,
        DocumentosExService,
        SeguimientoExService,
        EnvioExService,
        NumerosSeguridadExService,
        CopiaCFExService,
        LaboratorioExService,
    ],
})
export class SolicitudesExModule {}
